export default "__VITE_ASSET__BJmrlUjK__"